import axios from 'axios';

export function uploadFile({file = {}, type = 'image'}) {
    const data = new FormData();
    data.append('type', type);
    data.append('file', file);

    return axios({
        method: 'post',
        url: '/api/v1/file/upload',
        withCredentials: true,
        data,
    });
}




// WEBPACK FOOTER //
// ./app/services/files.js